module.exports = __webpack_public_path__ + "static/img/Bachelor_010277.4535a44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010277.jpg
// module id = 136
// module chunks = 0